<div class="layout">
  <app-topbar></app-topbar>
  <div class="content">
    <app-sidebar [ngClass]="{'collapsed': !(isSidebarOpen$ | async) }"></app-sidebar>
    <div [ngClass]="(isSidebarOpen$ | async) ? 'col-md-10 offset-md-2 p-3' : 'col-md-12 p-2'">
      <div class="container1 mt-1 mb-2">
        <div class="text-white text-left p-2 rounded-top container-header">
          <h5 class="px-3 m-1"><b>{{title}}</b></h5>
        </div>
        <div class="bg-white text-dark rounded-bottom p-3 injected-content">
          <ng-content></ng-content>
        </div>
      </div>
      <p class="text-center text-dark py-2">Desarrollado por Asociación Sur Austral de Chile | Iglesia Adventista del Séptimo Día</p>
    </div>
  </div>
</div>